import { render, staticRenderFns } from "./bomUpdate.vue?vue&type=template&id=1ed1d142"
import script from "./bomUpdate.vue?vue&type=script&lang=js"
export * from "./bomUpdate.vue?vue&type=script&lang=js"
import style0 from "./bomUpdate.vue?vue&type=style&index=0&id=1ed1d142&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports